<template>
  <vs-popup
    class="holamundo ekyc-popup-overlay ekyc-popup"
    :title="$t('ekyc.title')"
    :active.sync="localVisible"
    v-bind="$props"
    @close="closePopup"
    :button-close-hidden="isOnPaymentPath"
  >
    <div>
      <p>
        {{ $t('ekyc.remind') }}
      </p>
      <div class="text-center mt-4">
        <Button @click="redirectToUpdate" class="w-full md:w-auto">
          {{ $t('ekyc.gotoUpdate') }}


        </Button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import Button from "../Button/Button.vue";

export default {
  name: "EkycRemind",
  components: {
    Button,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localVisible: this.isVisible,
    };
  },
  watch: {
    isVisible(newVal) {
      this.localVisible = newVal;
    },
    // Khi `localVisible` thay đổi, emit sự kiện để cập nhật giá trị trong parent
    localVisible(newVal) {
      this.$emit("update:isVisible", newVal);
    },

    $route(to) {
      if (to.path === "/user/profile/payment") {
        this.localVisible = true; // Bật popup nếu đang ở path này
      }
    },
  },
  computed: {
    isOnPaymentPath() {
      return this.$route.path === "/user/profile/payment";
    },
  },
  methods: {
    closePopup ()  {
      if (this.isOnPaymentPath) this.localVisible = true
    },
    redirectToUpdate() {
      this.$router.push("/user/profile/info");
    },
  },
};
</script>

<style scoped>

.btn-update {
  background-color: #f50057;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.btn-update:hover {
  background-color: #d4004d;
}

.ekyc-popup {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Popup/EkycRemind.vue